import { render } from "./TemplatesAdd.vue?vue&type=template&id=363d73a2&scoped=true"
import script from "./TemplatesAdd.vue?vue&type=script&lang=js"
export * from "./TemplatesAdd.vue?vue&type=script&lang=js"

import "./TemplatesAdd.vue?vue&type=style&index=0&id=363d73a2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363d73a2"]])

export default __exports__